import React, { useState } from "react";

import { Card, IconButton, TextField } from "@material-ui/core";
import { Search } from "@material-ui/icons";

import { transform } from "ol/proj.js";

import { GEOCODE_LOOKUP } from "constants/api";

import { plainGet } from "utils/api";

import "./LocationSearchbar.css";

export default function LocationSearchbar(props) {
	const [searchText, setSearchText] = useState("");

	const handleTextChange = (event) => {
		setSearchText(event.target.value);
	};

	const checkKeyPress = (e) => {
		if (e.key === "Enter" || e.key === "NumpadEnter") {
			e.preventDefault();
			searchLocation();
		}
	};

	const searchLocation = () => {
		plainGet(`${GEOCODE_LOOKUP}?search=${encodeURIComponent(searchText)}`)
			.then((response) => {
				try {
					// Check if we have results
					if (response && response.status === "OK" && response.results && response.results.length > 0) {
						const result = response.results[0];
						const location = result.geometry.location;
						const viewport = result.geometry.viewport;

						// Extract coordinates (Google returns lat, lng)
						const lat = location.lat;
						const lng = location.lng;

						// Transform coordinates from EPSG:4326 to EPSG:3857 for OpenLayers
						const transformedCoords = transform([lng, lat], "EPSG:4326", "EPSG:3857");

						// Set map center
						window.map.getView().setCenter(transformedCoords);

						// If viewport is available, fit the map to the viewport
						if (viewport) {
							console.log("fitting map using viewport");
							const southwest = transform([viewport.southwest.lng, viewport.southwest.lat], "EPSG:4326", "EPSG:3857");
							const northeast = transform([viewport.northeast.lng, viewport.northeast.lat], "EPSG:4326", "EPSG:3857");

							// Fit map to viewport bounds
							window.map.getView().fit([southwest[0], southwest[1], northeast[0], northeast[1]], {
								padding: [50, 50, 50, 50],
								duration: 1000,
							});
						} else {
							console.log("fitting map using location type");
							// Determine zoom level based on location type
							const locationType = result.types && result.types.length > 0 ? result.types[0] : "default";
							const zoomLevel = getCorrectZoomLevel(locationType);

							// Set zoom level
							window.map.getView().setZoom(zoomLevel);
						}
					} else {
						//todo: show feedback to the user
						console.log("No results found for the search query");
					}
				} catch (error) {
					console.log("Location search error: ", error);
				}
			})
			.catch((error) => {
				console.log("API request error: ", error);
			});
	};

	const getCorrectZoomLevel = (addressType) => {
		switch (addressType) {
			case "locality": // City
				return 12;
			case "sublocality": // Neighborhood
				return 16;
			case "route": // Street
				return 17;
			case "street_address": // Specific address
				return 20;
			case "postal_code": // ZIP code
				return 14;
			case "administrative_area_level_3": // County subdivision
				return 14;
			case "administrative_area_level_2": // County
				return 10;
			case "administrative_area_level_1": // State
				return 7;
			case "country": // Country
				return 4;
			case "establishment": // Business/POI
				return 18;
			case "point_of_interest": // Landmark
				return 16;
			case "natural_feature": // Park, mountain, etc.
				return 14;
			case "premise": // Building
				return 19;
			case "subpremise": // Unit/Apartment
				return 20;
			default:
				return 15; // Default zoom level
		}
	};

	return (
		<Card id="locationSearchPanel">
			<TextField
				placeholder="Search for a location"
				defaultValue=""
				id="locationSearchField"
				onKeyDown={checkKeyPress}
				onChange={handleTextChange}
			/>
			<IconButton onClick={searchLocation}>
				<Search />
			</IconButton>
		</Card>
	);
}
